<template>
  <div class="tasks">
    <div class="tasks__table-wrapper">
      <custom-table
        :title="title"
        :tableData="dataArray"
        :pagesCount="pagesCount"
        :paginationMethod="'fetchTasks'"
        class="tasks__table"
        :extLoading="loading"
      >
        <template slot="headerData">
          <div class="table__flex-header">
            <div class="table__title">{{ title }}</div>
          </div>
        </template>
        <template slot="thead">
          <th>Name</th>
          <th>Created</th>
        </template>
        <template slot-scope="{ row }">
          <td>{{ row.scheme }}</td>
          <td>{{ row.created_at }}</td>
          <td>
            <div class="tasks__options-col">
              <p-button
                size="sm"
                type="default"
                style="margin-right:10px"
                @click.native="onDetailsClick(row.id)"
                >Details</p-button
              >
              <drop-down tag="div" title="Options">
                <a class="dropdown-item" @click="modalToggle(row.id)">Delete</a>
              </drop-down>
            </div>
          </td>
        </template>
      </custom-table>
    </div>

    <new-task class="tasks__form" />

    <div v-if="loadingTask" class="w-100 text-center">
      <scale-loader :loading="true" height="50px" width="15px" class="mt-5" />
    </div>

    <div v-if="!loadingTask" class="tasks__annotations">
      <custom-table
        v-if="annotations.length > 0"
        :title="'PENDING ANNOTATIONS'"
        :tableData="annotations"
        class="tasks__annotations-table"
      >
        <template slot="thead">
          <th>Filename</th>
          <th>Created</th>
          <th>Type</th>
        </template>
        <template slot-scope="{ row }">
          <td>{{ row.filename }}</td>
          <td>{{ convertData(row.created_at) }}</td>
          <td>{{ row.datatype }}</td>
          <!-- <td>
            <div class="tasks__options-col">
              <p-button size="sm" type="default">Open</p-button>
            </div>
          </td> -->
        </template>
      </custom-table>

      <div v-else class="w-100 text-center">
        <h3>No annotations</h3>
      </div>
    </div>
  </div>
</template>

<script>
import { apiError } from "@/util/ErrorMessage.js";
import CustomTable from "../../customReusableComponents/CustomTable";
import NewTask from "./NewTask/NewTask";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";

export default {
  components: {
    CustomTable,
    NewTask,
    ScaleLoader
  },
  data() {
    return {
      title: "TASKS",
      loading: false,
      loadingTask: false
    };
  },
  computed: {
    pagesCount() {
      const entries = this.$store.getters.getTasksQuantity;
      return Math.ceil(entries / 5);
    },
    dataArray() {
      const entries = this.$store.getters.tasks;
      entries.map(item => {
        item.created_at = this.convertData(item.created_at);
      });
      return entries;
    },
    annotations() {
      const annotations = this.$store.getters.getTasksAnnotations;
      return annotations;
    }
  },
  methods: {
    convertData(data) {
      return new Date(data)
        .toDateString()
        .split(" ")
        .slice(1, 4)
        .join(" ");
    },
    modalToggle(id) {
      this.$store.dispatch("toggleModal");
      this.$store.dispatch("sendIdToModal", id);
    },
    async onDetailsClick(id) {
      this.loadingTask = true;

      try {
        await this.$store.dispatch("fetchAnnotations", id);
      } catch (error) {
        apiError(error);
      }

      this.loadingTask = false;
    }
  },
  async created() {
    this.loading = true;

    try {
      await this.$store.dispatch("fetchTasks", 1);
    } catch (error) {
      apiError(error, this);
    }

    this.loading = false;
  }
};
</script>
<style lang="scss" scoped>
.tasks {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  @media only screen and (min-width: 320px) and (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }

  &__table-wrapper {
    width: 60%;
    overflow: auto;
    margin-bottom: 20px;

    @media only screen and (min-width: 320px) and (max-width: 768px) {
      width: 100%;
      margin-bottom: 10px;
    }
  }

  &__table {
    width: 100%;

    @media only screen and (min-width: 320px) and (max-width: 900px) {
      width: 600px;
    }
  }

  &__options-col {
    display: flex;
    align-items: center;
  }

  &__form {
    width: 35%;
    margin-bottom: 20px;

    @media only screen and (min-width: 320px) and (max-width: 480px) {
      width: 100%;
    }
  }

  &__annotations {
    width: 100%;
    overflow: auto;
  }

  &__annotations-table {
    width: 100%;

    @media only screen and (min-width: 320px) and (max-width: 900px) {
      width: 700px;
    }
  }
}
</style>
